import { IconChartBar, IconFileText, IconWorld } from '@tabler/icons-react'

export const ADMIN_NAV_CONFIG = [
  { to: '/documents', icon: IconFileText, key: 'documents', labelKey: 'adminNav.documents' },
  { to: '/web-pages', icon: IconWorld, key: 'web-pages', labelKey: 'adminNav.webPages' },
  { to: '/reports', icon: IconChartBar, key: 'reports', labelKey: 'adminNav.reports' },
] as const
